<template>
	<div>
		<div class="brdr_box_w_checkbox layout-column">

			<v-switch label="Show data from all funnels in your account?"
			          v-model="appConfig['account_wide']" :value="appConfig['account_wide']" >
				<template v-slot:info>
					<p>
						If checked, will show recent sales/optins from all funnels in your account. <br>
						If unchecked, it will only show sales/optins that occurred in the current funnel.
					</p>
				</template>
			</v-switch>

			<v-switch label="Show data from all steps in your current funnel?"
			          v-model="appConfig['funnel_wide']" :value="appConfig['funnel_wide']" >
				<template v-slot:info>
					<p>Shows recent sales/optins from other funnel steps as well,
						if unchecked it will only show sales/optins that occurred in the current step.
					</p>
				</template>
			</v-switch>

		</div>

		<div class="brdr_box_w_checkbox layout-column layout-stretch">
			<h3 class="margin-b-10">Message to show
				<info-icon interactive>
					<div>
						<p>
							This can be something like:
						</p>
						<p class="info-message">
							Signed up for <b>{{ '{'+'{productname}'+'}' }}</b>
						</p>
						<p>
							Funnelish will automatically replace <b>{{ '{'+'{productname}'+'}' }}</b> with the product name your customers bought (if any).
						</p>
					</div>
				</info-icon>
			</h3>
			<div>
				<input-field required v-model="appConfig['message_text']" :placeholder="`eg. Bought {{productname}}`" />
			</div>
		</div>
		<div class="brdr_box_w_checkbox layout-column layout-stretch " >
			<div class="layout-row layout-stretch">
				<div class="layout-column flex layout-stretch">
					<h3>Theme</h3>
					<v-select class="flex" v-model="appConfig['theme']"
					          :options="themes"
					          label="name"
					          :reduce="x => x.id"
					          :searchable="false"
					          append-to-body />
				</div>
				<div style="width: 20px"></div>
				<div class="layout-column flex layout-stretch">
					<h3>Style</h3>
					<v-select class="flex" v-model="appConfig['style']"
					          :options="styles"
					          label="name"
					          :reduce="x => x.id"
					          :searchable="false"
					          append-to-body />
				</div>
				<div style="width: 20px"></div>
				<div class="layout-column flex layout-stretch">
					<h3>Position</h3>
					<v-select class="flex" v-model="appConfig['position']"
					          :options="positions"
					          label="name"
					          :reduce="x => x.id"
					          :searchable="false"
					          append-to-body />
				</div>
			</div>

			<div style="height: 20px"></div>

			<div class="layout-row layout-stretch">
				<div class="layout-column flex layout-stretch">
					<h3>In effect</h3>
					<v-select class="flex" v-model="appConfig['in_effect']"
					          :options="inEffects"
					          label="name"
					          :reduce="x => x.id"
					          :searchable="false"
					          append-to-body />
				</div>
				<div style="width: 20px"></div>
				<div class="layout-column flex layout-stretch">
					<h3>Out effect</h3>
					<v-select class="flex" v-model="appConfig['out_effect']"
					          :options="outEffects"
					          label="name"
					          :reduce="x => x.id"
					          :searchable="false"
					          append-to-body />
				</div>
			</div>
		</div>
		<div class="brdr_box_w_checkbox layout-column layout-stretch " >
			<h3 class="margin-b-10">
				Show notifications for <b>(required)</b>
				<info-icon>
					Select which customer behavior to show popups for,
					it can be shown whenever there is an <b>optin and/or a purchase.</b>
				</info-icon>
			</h3>
			<v-select class="flex" v-model="appConfig['events']" taggable multiple
			          :options="['Purchases', 'Optins']"
			          :reduce="x => x"
			          append-to-body>

			</v-select>
		</div>

		<div class="brdr_box_w_checkbox layout-column layout-stretch flex">
			<h3 class="margin-b-10">Delays
				<info-icon>
					<p><b>Show after: </b> Set the delay in seconds between each popup (this should always be greater than <b>show for</b>).</p>
					<p><b>Show for: </b> Set the duration for which the popup will be shown.</p>
				</info-icon>
			</h3>
			<div class="flex layout-row layout-stretch">
				<input-field class="flex" label="Show after" :min="1" :step="1" :max="200" append="seconds"
				             type="number" required v-model="appConfig['delay']" />
				<div style="width: 15px"></div>
				<input-field class="flex" label="Show for" :min="1" :step="1" :max="200" append="seconds"
				             type="number" required v-model="appConfig['duration']" @input="durationChanged($event)" />
			</div>
		</div>

	</div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue"
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import VSwitch from "@/components/base/v-switch";
export default {
    name: 'ProofySettings',
    props: ['dataBufferObject'],
    components: {
	    VSwitch,
	    InputField,
	    InfoIcon,
        Tooltip
    },
    computed: {
        pixelsCount() {
            return this.appConfig.pixels.length
        }
    },
    data() {
        return {
	        themes: [
		        {id: "white", name:"White"},
		        {id: "dark", name:"Dark"},
		        {id: "pink", name:"Pink"},
	        ],
	        styles: [
		        {id: "round", name:"Round"},
		        {id: "square", name:"Square"},
	        ],
	        positions: [
		        {id: "bottom left", name:"Bottom Left"},
		        {id: "bottom right", name:"Bottom Right"},
		        {id: "top left", name:"Top Left"},
		        {id: "top right", name:"Top Right"},
	        ],
	        inEffects: [
		        {id: "slideBottom", name:"Slide from bottom"},
		        {id: "slideTop", name:"Slide from top"},
		        {id: "slideRight", name:"Slide from right"},
		        {id: "slideLeft", name:"Slide from left"},
	        ],
	        outEffects: [
		        {id: "slideBottom", name:"Slide to bottom"},
		        {id: "slideTop", name:"Slide to top"},
		        {id: "slideRight", name:"Slide to right"},
		        {id: "slideLeft", name:"Slide to left"},
	        ],
            showAlert: false,
            appConfig: {},
        }
    },
    methods: {
	    durationChanged(v) {
	    	try {
			    if (parseInt(v) >= parseInt(this.appConfig["delay"])) {
				    this.appConfig["delay"] = parseInt(v) + 1;
			    }
		    } catch {}
	    },
        cAlert() {
            this.showAlert = true;
        },
        addItem() {
            if(this.pixelsCount<=3) {
                var saveStr = JSON.stringify(this.appConfig.pixels);
                var newPixels = JSON.parse(saveStr);
                newPixels.push({value: ''});
                this.$emit('update', newPixels, 'pixels');
            } else {
                this.cAlert()
            }
        },
        editItem(ev, index) {
            var saveStr = JSON.stringify(this.appConfig.pixels);
            var newPixels = JSON.parse(saveStr);
            newPixels[index].value = ev;
            this.$emit('update', newPixels, 'pixels');
        },
        deleteItem(index) {
            var saveStr = JSON.stringify(this.appConfig.pixels);
            var newPixels = JSON.parse(saveStr);
            newPixels.splice(index, 1);
            this.$emit('update', newPixels, 'pixels');
        }
    },
    created(){
        if(this.dataBufferObject) {
            this.appConfig = this.dataBufferObject;
        } else {
            this.appConfig = JSON.parse("{\"lead_to_atc\":false,\"pixels\":[{\"value\":\"\"}],\"pixel\":\"442023039471578\"}")
        }
    }
}
</script>
